import logo from './logo.svg';
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

import {HContainer} from './HContainer';

function App() {

  return (
    <HContainer />
  );
}

export default App;
